import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Terms of Service and Privacy Policy pages. The wording is placeholder text for the demo: the
 * operator must replace it with their own reviewed terms before real customers sign up.
 */
function LegalPage({ title, id, children }) {
  return (
    <div className="container py-5" id={id} style={{ maxWidth: 760 }}>
      <div className="card p-4 p-md-5 shadow-sm border bg-white">
        <div className="d-flex align-items-center mb-3">
          <i className="fa fa-bolt fa-lg me-2 text-primary" aria-hidden="true" />
          <span className="fw-bold text-primary">ChargeOS</span>
        </div>
        <h1 className="h3 fw-bold text-primary mb-2">{title}</h1>
        <div className="alert alert-info small" role="note">
          <i className="fa fa-flask me-1" aria-hidden="true" />Demo text. This is placeholder wording for the demonstration environment, not a reviewed legal document.
        </div>
        {children}
        <div className="mt-4 d-flex flex-wrap gap-2">
          <Link to="/register" className="btn btn-primary">Back to registration</Link>
          <Link to="/" className="btn btn-outline-secondary">Find stations</Link>
        </div>
      </div>
    </div>
  );
}

export function TermsPage() {
  return (
    <LegalPage title="Terms of Service" id="terms-page">
      <h2 className="h6 fw-bold mt-3">1. The service</h2>
      <p className="small text-muted">ChargeOS lets you find EV charging stations, reserve a connector, start and stop charging sessions, and pay for them from a prepaid wallet.</p>
      <h2 className="h6 fw-bold mt-3">2. Your account</h2>
      <p className="small text-muted">You are responsible for activity on your account and for keeping your password private. Tell the operator promptly if you believe someone else has used it.</p>
      <h2 className="h6 fw-bold mt-3">3. Pricing and payment</h2>
      <p className="small text-muted">The price for a session is the tariff shown for the station when you start. A pre-authorization hold is placed on your wallet at the start and released when the session is billed. Reservation fees are charged when a reservation is confirmed.</p>
      <h2 className="h6 fw-bold mt-3">4. Using the chargers</h2>
      <p className="small text-muted">Follow the instructions on the charger and move your vehicle when charging ends so others can use the bay. Do not use damaged equipment; report it through the app.</p>
      <h2 className="h6 fw-bold mt-3">5. Billing questions</h2>
      <p className="small text-muted">If a session was billed incorrectly, use &quot;Report a problem&quot; on the session receipt. Customer Care reviews the charger&apos;s meter record and replies.</p>
    </LegalPage>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" id="privacy-page">
      <h2 className="h6 fw-bold mt-3">What is collected</h2>
      <p className="small text-muted">Your name, email address and mobile number; your vehicles; your charging sessions, reservations and wallet transactions; and, if you allow it, your approximate location to show the nearest stations.</p>
      <h2 className="h6 fw-bold mt-3">How it is used</h2>
      <p className="small text-muted">To run your account, bill charging sessions, handle billing questions, keep the charging network secure, and meet legal and accounting obligations.</p>
      <h2 className="h6 fw-bold mt-3">Location</h2>
      <p className="small text-muted">Location is used only to order the station list and centre the map. It is rounded before it is sent and is not stored with your account.</p>
      <h2 className="h6 fw-bold mt-3">Your rights</h2>
      <p className="small text-muted">Under the Philippine Data Privacy Act of 2012 (RA 10173) you may ask to access, correct or delete your personal data. Contact the operator to make a request.</p>
    </LegalPage>
  );
}
